module.exports = __webpack_public_path__ + "static/media/profile1.a51d4e64.jpg";